<template>
  <div>
    <div v-if="loading_page === true">
      <v-sheet :color="`grey ${theme.isDark ? 'darken-2' : 'lighten-4'}`" class="pa-3">
        <v-skeleton-loader type="article, actions"></v-skeleton-loader>
      </v-sheet>
    </div>
    <div v-else>
      <v-card elevation="6">
        <v-form ref="faqs_add" @submit.prevent="save_data">
          <div class="pa-2">
            <div class="grid_full">
              <div class="mt-3 ma-1">
                <v-text-field color="#86bc3a" type="text" label="คำถาม" hide-details="auto" v-model="question" :rules="[v => !!v || 'กรุณากรอกคำถาม']" outlined></v-text-field>
              </div>
              <div class="mt-3 ma-1">
                <div>คำถาม</div>
                <quillEditor ref="myQuillEditor" v-model="question_content"/>
              </div>
            </div>
            <div class="text-center pt-6 pb-6">
              <v-btn large class="white--text grad-success-bg mobile_btn" style="font-size: 18px" type="submit">บันทึก</v-btn>
            </div>
          </div>
        </v-form>
      </v-card>
      <v-overlay :value="overlay" class="z_index">
        <div class="text-center">
          <v-progress-circular
              indeterminate
              size="70"
              width="7"
              color="#86bc3a"
          ></v-progress-circular>
          <div>โปรดรอสักครู่ระบบกำลังประมวลผล...</div>
        </div>
      </v-overlay>
    </div>
  </div>
</template>

<script>
import 'quill/dist/quill.core.css' // import styles
import 'quill/dist/quill.snow.css' // for snow theme
import 'quill/dist/quill.bubble.css' // for bubble theme
import {quillEditor} from 'vue-quill-editor'
import {HTTP} from "@/axios";
import Swal from "sweetalert2";

export default {
  name: "Faqs_add",
  components: {
    quillEditor
  },
  data() {
    return {
      loading_page: false,
      overlay: false,
      question: '',
      question_content: '',
      editorOption: {
        modules: {
          toolbar: ['bold', 'italic', 'underline', 'strike']
        }
      },
    }
  },
  methods: {
    save_data() {
      if (this.$refs.faqs_add.validate()) {
        Swal.fire({
          title: 'คุณต้องการบันทึกข้อมูลหรือไม่ ?',
          icon: 'warning',
          showDenyButton: true,
          showCancelButton: false,
          confirmButtonText: `ตกลง`,
          denyButtonText: `ยกเลิก`,
        }).then((res) => {
          if (res.isConfirmed === true) {
            HTTP.post('/manage-website/faqs/create', {
              title: this.question,
              content: this.question_content
            }).then((res) => {
              if (res.data.success === true) {
                Swal.fire({
                  title: 'บันทึกข้อมูลเรียบร้อย !',
                  icon: 'success',
                  showDenyButton: false,
                  showCancelButton: false,
                  confirmButtonText: `ตกลง`,
                  denyButtonText: `ยกเลิก`,
                }).then(() => {
                  this.$router.push('/faqspage')
                })
              }
            })
          }
        })
      }
    },
  },
}
</script>

<style scoped>
.grid_full {
  display: grid;
  grid-template-columns: 100%;
  grid-gap: 15px 0;
}
.mobile_btn {
  width: 30%;
}
@media only screen and (max-width: 1180px) {
  .mobile_btn {
    width: 40%;
  }
}
@media only screen and (max-width: 500px) {
  .mobile_btn {
    width: 100%;
  }
}
</style>
